import { Button, Flex, Grid, Skeleton } from "antd";
import { ExpenseType } from "@/types/expenseType";

interface ExpenseFormTypeProps {
  expenseType?: ExpenseType;
  expenseTypes: ExpenseType[];
  isLoading: boolean;
  setExpenseType?: (expenseType: ExpenseType) => void;
}

const ExpenseFormType = ({
  expenseType,
  expenseTypes,
  isLoading,
  setExpenseType,
}: ExpenseFormTypeProps) => {
  const breakpoint = Grid.useBreakpoint();
  const skeletonStyle: React.CSSProperties = {
    width: 100,
    height: 32,
    borderRadius: 8,
  };

  return (
    <Flex
      vertical={false}
      gap={16}
      justify="start"
      style={{
        width: breakpoint.xl ? "70%" : "100%",
      }}
      wrap
    >
      {isLoading ? (
        <>
          <Skeleton.Button active style={skeletonStyle} />
          <Skeleton.Button active style={skeletonStyle} />
          <Skeleton.Button active style={skeletonStyle} />
        </>
      ) : (
        expenseTypes?.map(
          (type) =>
            type.is_active && (
              <Button
                key={type.id}
                color="default"
                variant="solid"
                size="middle"
                style={{
                  padding: "16px 32px",
                  flex: "0 1 auto",
                  textTransform: "capitalize",
                  transition: "none",
                  animation: "none",
                  boxShadow: "none",
                  backgroundColor:
                    expenseType?.id === type.id ? "black" : "#0000000a",
                  color: expenseType?.id === type.id ? "white" : "black",
                }}
                onClick={() => setExpenseType?.(type)}
              >
                {type.name.toLowerCase()}
              </Button>
            )
        )
      )}
    </Flex>
  );
};

export default ExpenseFormType;
